<template>
  <div class="accordion-body">
    <div display="flex">
      <div v-if="exercise.warmupSetCount > 0 && warmupSetsDone < exercise.warmupSetCount">
        <div class="addWarmup">
          <button type="button" class="btn btn-primary" @click="addWarmupSet()">
            <BIconClipboard2CheckFill></BIconClipboard2CheckFill>
          </button>
        </div>
        <table>
          <tr><th class="head">Warmup Set</th></tr>
          <tr v-for="warmupSet in exercise.warmupSets" :key="warmupSet">
            <td v-if="!warmupSet.done"><span>{{warmupSet.reps}} * {{warmupSet.weight}}</span></td>
            <td v-else><span class="warmupSetDone">{{warmupSet.reps}} * {{warmupSet.weight}}</span></td>
          </tr>
        </table>
      </div>
      <div>
        <table>
          <tr><th class="head">Previous</th><th class="head">Current</th></tr>
          <tr v-for="index in setCount" :key="index">
            <td>{{previousSet(index - 1)}}</td>
            <td v-if="this.exercise.current && this.exercise.current.length >= index" >{{currentSet(index - 1)}}<span class="editButton" @click="$emit('open-modal', this.index, index - 1)">&nbsp;<BIconPencilSquare></BIconPencilSquare></span></td>
            <td v-else ><span class="pending">{{currentSet(index - 1)}}</span></td>
          </tr>
        </table>
        <div class="note" v-if="exercise.note">
          <div><b>Note</b></div>
          <div>{{exercise.note}}</div>
        </div>
      </div>
      <div class="addSet">
        <button type="button" class="btn btn-primary" @click="$emit('open-modal', this.index)">
          <BIconClipboardPlusFill></BIconClipboardPlusFill>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import {
  BIconClipboardPlusFill,
  BIconClipboard2CheckFill,
  BIconPencilSquare
} from 'bootstrap-icons-vue';
const _ = require('lodash');

export default {
  name: 'ExerciseDetail',
  props: {
    index: Number,
    exercise: {name: String, sets: Number, previous: Array, current: Array},
  },
  emits: ['open-modal', 'restart-timer', 'warmup-set-done'],
  components: {
    BIconClipboardPlusFill,
    BIconClipboard2CheckFill,
    BIconPencilSquare
  },
  data() {
    return {
      warmupSetsDone: 0,
    }
  },
  mounted() {
    if (this.exercise.warmupActive) {
      const doneSets = _.filter(this.exercise.warmupSets, 'done')
      this.warmupSetsDone = doneSets.length
    }
  },
  methods: {
    roundNearest5(num) {
      return Math.round(num / 5) * 5;
    },
    addWarmupSet() {
      this.$emit('warmup-set-done', this.exercise, this.warmupSetsDone);
      this.warmupSetsDone += 1
      this.$emit('restart-timer')
    },
    currentSet(key) {
      if (this.exercise.current && this.exercise.current[key]) {
        if (this.exercise.type === 'time') {
          return this.exercise.current[key].time + 's'
        } else if (this.exercise.type === 'bodyweight') {
          return this.exercise.current[key].reps;
        } else {
          if (this.exercise.current[key].weightLbs) {
            return this.exercise.current[key].reps + ' * ' + this.exercise.current[key].weight + ' (' + this.exercise.current[key].weightLbs + ' lbs)';
          } else {
            return this.exercise.current[key].reps + ' * ' + this.exercise.current[key].weight;
          }
        }
      } else {
        if (this.exercise.type !== 'time') {
          return '- ' + this.exercise.reps + ' -'
        } else {
          return '- ' + this.exercise.time + 's -'
        }
      }
    },
    previousSet(key) {
      if (this.exercise.previous && this.exercise.previous[key]) {
        if (this.exercise.type === 'time') {
          return this.exercise.previous[key].time + 's'
        } else if (this.exercise.type === 'bodyweight') {
          return this.exercise.previous[key].reps;
        } else {
          if (this.exercise.previous[key].weightLbs) {
            return this.exercise.previous[key].reps + ' * ' + this.exercise.previous[key].weight + ' (' + this.exercise.previous[key].weightLbs + ' lbs)';
          } else {
            return this.exercise.previous[key].reps + ' * ' + this.exercise.previous[key].weight;
          }
        }
      } else {
        return '--'
      }
    }
  },
  computed: {
    setCount() {
      let setCount = this.exercise.sets && parseInt(this.exercise.sets) > 0 ? this.exercise.sets : 1;
      if (this.exercise.previous && this.exercise.previous.length > setCount) {
        setCount = this.exercise.previous.length;
      }
      if (this.exercise.current && this.exercise.current.length > setCount) {
        setCount = this.exercise.current.length
      }
      return setCount
    }
  }
}
</script>

<style>
.head {
  width: 150px
}
.addSet {
  display:grid;
  justify-content: end;
}
.addWarmup {
  float:right;
  position:relative;
}
.pending {
  color: gray;
}

.editButton {
  position: relative;
  top: -2px;
  cursor: pointer;
  float:right;
  padding-right:15px
}

.note {
  margin-top: 10px;
}
.warmupSetDone {
  text-decoration: line-through;
}
</style>
